// ============================================================================
// SMART BOOKING PORTAL · DESTINATION & HOTEL REGISTRY
// ============================================================================
// This is the single source of truth for the KC India booking portal.
// Add a new destination or a new hotel by appending an entry below —
// the /book page reads from this file automatically.
//
// SCHEMA
//   { id, name, subtitle, icon, image, tagline, hotels: [ { id, name, note?, featured? } ] }
//
// IMAGES
//   Use verified Unsplash/Pexels URLs. If an image fails, the destination card
//   still renders with a gradient overlay + name.
// ============================================================================

export const DESTINATIONS = [
  {
    id: "kedarnath",
    name: "Kedarnath",
    subtitle: "The seat of Mahadev",
    icon: "temple",
    tagline: "Sacred Char Dham · 3,583 m",
    image: "https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?auto=format&fit=crop&w=1400&q=80",
    hotels: [
      { id: "kc-sersi",                name: "Kedarnath Cottage, Sersi",                     note: "Our signature property", featured: true },
      { id: "heritage-helipad-sersi",  name: "Hotel Near Heritage Aviation Helipad, Sersi",  note: "Yatri favourite · walking distance" },
      { id: "arrow-helipad-sersi",     name: "Hotel Near Arrow Helipad, Sersi" },
      { id: "himalayan-helipad-sersi", name: "Hotel Near Himalayan Helipad, Sersi" },
      { id: "sonprayag-taxi",          name: "Hotel Near Sonprayag Taxi Stand" },
      { id: "gaurikund",               name: "Hotel Near Gaurikund" },
      { id: "kedarnath-temple",        name: "Hotel Near Kedarnath Temple" },
      { id: "phata-helipad",           name: "Hotel Near Phata Helipad" },
      { id: "guptkashi-helipad",       name: "Hotel Near Guptkashi Helipad" },
      { id: "triyuginarayan-temple",   name: "Hotel Near Triyuginarayan Temple",             note: "Sacred wedding site" },
    ],
  },
  {
    id: "badrinath",
    name: "Badrinath",
    subtitle: "Abode of Lord Vishnu",
    icon: "temple",
    tagline: "Sacred Char Dham · 3,133 m",
    image: "https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?auto=format&fit=crop&w=1400&q=80&sat=-20",
    hotels: [
      { id: "badrinath-temple",  name: "Hotel Near Badrinath Temple" },
      { id: "mana-village",      name: "Hotel Near Mana Village",     note: "India's last village" },
      { id: "joshimath",         name: "Hotel Near Joshimath" },
      { id: "pandukeshwar",      name: "Hotel Near Pandukeshwar" },
    ],
  },
  {
    id: "gangotri",
    name: "Gangotri",
    subtitle: "Where Ganga descends",
    icon: "temple",
    tagline: "Sacred Char Dham · 3,100 m",
    image: "https://images.unsplash.com/photo-1544198365-f5d60b6d8190?auto=format&fit=crop&w=1400&q=80",
    hotels: [
      { id: "gangotri-temple",  name: "Hotel Near Gangotri Temple" },
      { id: "harsil-valley",    name: "Hotel Near Harsil Valley",   note: "Apple orchards · scenic" },
      { id: "dharali",          name: "Hotel Near Dharali" },
      { id: "uttarkashi",       name: "Hotel Near Uttarkashi" },
    ],
  },
  {
    id: "yamunotri",
    name: "Yamunotri",
    subtitle: "Source of the Yamuna",
    icon: "temple",
    tagline: "Sacred Char Dham · 3,293 m",
    image: "https://images.unsplash.com/photo-1544198365-f5d60b6d8190?auto=format&fit=crop&w=1400&q=80&sat=-15",
    hotels: [
      { id: "yamunotri-temple", name: "Hotel Near Yamunotri Temple" },
      { id: "janki-chatti",     name: "Hotel Near Janki Chatti",    note: "Trek starting point" },
      { id: "hanuman-chatti",   name: "Hotel Near Hanuman Chatti" },
      { id: "barkot",           name: "Hotel Near Barkot" },
    ],
  },
  {
    id: "hemkund",
    name: "Hemkund Sahib & Valley of Flowers",
    subtitle: "The sacred lake & alpine bloom",
    icon: "flower",
    tagline: "Sikh pilgrimage · UNESCO valley",
    image: "https://images.unsplash.com/photo-1465146344425-f00d5f5c8f07?auto=format&fit=crop&w=1400&q=80",
    hotels: [
      { id: "govindghat",         name: "Hotel Near Govindghat",         note: "Trek base camp" },
      { id: "ghangaria",          name: "Hotel Near Ghangaria" },
      { id: "hemkund-sahib",      name: "Hotel Near Hemkund Sahib" },
      { id: "valley-of-flowers",  name: "Hotel Near Valley of Flowers",  note: "Peak bloom: Jul–Aug" },
    ],
  },
  {
    id: "rishikesh",
    name: "Rishikesh",
    subtitle: "The Yoga Capital of the World",
    icon: "om",
    tagline: "Ganga · Yoga · Adventure",
    image: "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?auto=format&fit=crop&w=1400&q=80",
    hotels: [
      { id: "ram-jhula",     name: "Hotel Near Ram Jhula" },
      { id: "laxman-jhula",  name: "Hotel Near Laxman Jhula" },
      { id: "tapovan",       name: "Hotel Near Tapovan" },
      { id: "shivpuri",      name: "Hotel Near Shivpuri",  note: "Rafting hub" },
    ],
  },
  {
    id: "haridwar",
    name: "Haridwar",
    subtitle: "Gateway to the Gods",
    icon: "lamp",
    tagline: "Ganga Aarti · Kumbh Mela city",
    image: "https://images.unsplash.com/photo-1560195587-4a9256134f68?auto=format&fit=crop&w=1400&q=80",
    hotels: [
      { id: "har-ki-pauri",   name: "Hotel Near Har Ki Pauri",              note: "Ganga aarti steps" },
      { id: "haridwar-rly",   name: "Hotel Near Haridwar Railway Station" },
      { id: "shantikunj",     name: "Hotel Near Shantikunj" },
      { id: "bhupatwala",     name: "Hotel Near Bhupatwala" },
    ],
  },
  {
    id: "dehradun",
    name: "Dehradun",
    subtitle: "Capital of Uttarakhand",
    icon: "plane",
    tagline: "Airport hub · Doon Valley",
    image: "https://images.unsplash.com/photo-1587922546925-1b1e6a06d5e5?auto=format&fit=crop&w=1400&q=80",
    hotels: [
      { id: "jolly-grant",    name: "Hotel Near Jolly Grant Airport",       note: "For flight arrivals" },
      { id: "dehradun-rly",   name: "Hotel Near Dehradun Railway Station" },
      { id: "isbt-dehradun",  name: "Hotel Near ISBT Dehradun" },
      { id: "clock-tower",    name: "Hotel Near Clock Tower" },
    ],
  },
  {
    id: "mussoorie",
    name: "Mussoorie",
    subtitle: "Queen of the Hills",
    icon: "mountain",
    tagline: "Hill station · 2,005 m",
    image: "https://images.unsplash.com/photo-1626621341517-bbf3d9990a23?auto=format&fit=crop&w=1400&q=80&hue=200",
    hotels: [
      { id: "mall-road",      name: "Hotel Near Mall Road" },
      { id: "gun-hill",       name: "Hotel Near Gun Hill",         note: "Cable car point" },
      { id: "library-chowk",  name: "Hotel Near Library Chowk" },
      { id: "kempty-falls",   name: "Hotel Near Kempty Falls" },
    ],
  },
  {
    id: "lansdowne",
    name: "Lansdowne",
    subtitle: "The quiet cantonment",
    icon: "trees",
    tagline: "Pine forests · 1,706 m",
    image: "https://images.unsplash.com/photo-1447752875215-b2761acb3c5d?auto=format&fit=crop&w=1400&q=80",
    hotels: [
      { id: "bhulla-tal",       name: "Hotel Near Bhulla Tal" },
      { id: "tip-in-top",       name: "Hotel Near Tip-in-Top",         note: "Sunset viewpoint" },
      { id: "st-marys-church",  name: "Hotel Near St. Mary's Church" },
      { id: "gandhi-chowk",     name: "Hotel Near Gandhi Chowk" },
    ],
  },
];

export const findDestination = (id) => DESTINATIONS.find(d => d.id === id);
export const findHotel = (dest, hotelId) => dest?.hotels.find(h => h.id === hotelId);
